
import { computed, defineComponent, toRef } from "vue";
import { Link } from "@inertiajs/inertia-vue3";

export default defineComponent({
  props: {
    color: {
      type: String,
      default: () => "blue",
      validator: (value: string) => {
        // The value must match one of these strings
        return (
          [
            "primary",
            "secondary",
            "accent",
            "gray",
            "blue",
            "green",
            "red",
            "white",
            "yellow",
            "black-white",
            "white-black",
            "info",
          ].indexOf(value) !== -1
        );
      },
    },
    empty: {
      type: Boolean,
      default: () => false,
    },
    href: {
      type: String,
      default: () => "#",
    },
    target: {
      type: String,
      default: () => "_self",
      validator: (value: string) => {
        // The value must match one of these strings
        return ["_self", "_blank", "_parent", "_top"].indexOf(value) !== -1;
      },
    },
    type: {
      type: String,
      default: () => "button",
      validator: (value: string) => {
        // The value must match one of these strings
        return ["button", "submit", "inertia-link", "a"].indexOf(value) !== -1;
      },
    },
    size: {
      type: String,
      default: () => "md",
      validator: (value: string) => {
        // The value must match one of these strings
        return ["sm", "md"].indexOf(value) !== -1;
      },
    },
    disabled: { type: Boolean, default: false },
  },
  components: {},
  setup(props, context) {
    const disabled = toRef(props, "disabled");
    const color = toRef(props, "color");
    const type = toRef(props, "type");

    const classNames = computed(() => {
      return `button button--${color.value} ${
        props.empty ? "empty" : ""
      } size-${props.size}`;
    });

    function getComponentType(type: string) {
      switch (type) {
        case "inertia-link":
          return Link;
        case "a":
          return "a";
        case "button":
        case "submit":
        default:
          return "button";
      }
    }

    return {
      classNames,
      getComponentType,
      disabled,
      color,
      type,
    };
  },
});
